// Angular
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
// Transloco
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { Observable } from 'rxjs';
// Services
import { SavedSearchesService } from '@app/core/_base/utils/saved-searches.service';

@Component({
    selector: 'app-quick-saved-searches-counter',
    templateUrl: './quick-saved-searches-counter.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, RouterLink, AsyncPipe],
})
export class QuickSavedSearchesCounterComponent {
    private readonly translocoService = inject(TranslocoService);
    private readonly savedSearchesService = inject(SavedSearchesService);

    // public
    readonly languageChange$: Observable<string> = this.translocoService.langChanges$;
    readonly count = this.savedSearchesService.savedSearchesCountSignal;
}